module.exports = __webpack_public_path__ + "img/switzerland.128703c8.svg";